import React, {useEffect, useRef} from 'react';
import {Button, Modal} from "semantic-ui-react";
import '../styles.scss'

const ConfirmModal = ({trigger, setOpen, children, open, label, onConfirm, onClose, closeBtnLabel, confirmBtnLabel, className, disabledBtn, hideClose, hideConfirm}) => {
    // Закрытие крестиком/оверлеем/ESC вызывает Modal.onClose — вызываем переданный onClose (сброс loading и т.д.).
    // После «Да» Semantic UI может дернуть onClose повторно — не выполняем тогда сценарий отмены.
    const closedByConfirmRef = useRef(false);

    useEffect(() => {
        if (open) {
            closedByConfirmRef.current = false;
        }
    }, [open]);

    const dismiss = () => {
        if (closedByConfirmRef.current) {
            closedByConfirmRef.current = false;
            return;
        }
        onClose && onClose();
        setOpen(false);
    };

    const confirm = () => {
        closedByConfirmRef.current = true;
        // Сначала закрываем текущее окно: иначе onConfirm может открыть следующее (например вопрос КМ),
        // а setOpen(false) затем вызовет setConfirmModal(null) и сотрёт его тем же тиком.
        setOpen(false);
        onConfirm && onConfirm();
    };

    return (
        <Modal
            className={className}
            closeIcon
            onClose={dismiss}
            onOpen={() => setOpen(true)}
            open={open}
            trigger={trigger}
            size="tiny"
        >
            <Modal.Header>
                {label}
            </Modal.Header>
            <Modal.Content className='modal__content'>
                {children}
            </Modal.Content>
            <Modal.Actions className='modal__actions'>
                {hideClose ? null : (
                    <Button onClick={dismiss}>
                        {closeBtnLabel || 'Нет'}
                    </Button>
                )}
                {hideConfirm ? null : (
                    <Button className='modal__actions_yes' disabled={disabledBtn} onClick={confirm}>
                        {confirmBtnLabel || 'Да'}
                    </Button>
                )}
            </Modal.Actions>
        </Modal>
    );
};

export default ConfirmModal;



// WEBPACK FOOTER //
// ./App/components/Modals/ConfirmModal.jsx